// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* CookieConsent.css */
.cookie-consent-banner {
    position: fixed;
    bottom: 0;
    left: 0;
    height: 200px;
    width: 100%;
    background-color: rgba(0, 0, 0, 0.95) !important;
    color: white !important;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 15px 30px;
    z-index: 1005;
    opacity: 0;
    transition: opacity 0.5s;
}

.cookie-consent-banner.visible {
    opacity: 1;
}

.cookie-consent-content {
    flex: 1 1;
    text-align: left;
}

.consent-text {
    font-size: 24px;
    color: white !important;
}

.cookie-consent-buttons {
    display: flex;
    justify-content: center;
    margin-right: 50px;
}

.cookie-consent-button {
    background-color: transparent !important;
    border: 2px solid white !important;
    color: white !important;
    padding: 15px 30px !important;
    /* Increased padding for larger button */
    margin: 0 30px !important;
    cursor: pointer !important;
    font-size: 24px !important;
    /* Larger font size */
}

.cookie-consent-button.reject {
    background-color: transparent !important;
    border: none !important;
    /* Thicker border */
    color: white !important;
    padding: 5px 10px !important;
    /* Smaller padding for smaller button */
    font-size: 16px !important;
    /* Smaller font size */
}

a.cookie-link {
    color: #F1D600 !important;
}

.cookies-svg-content {
    width: 120px;
    height: 120px;
    border-radius: 120px;
    padding: 20px;
    border: 2px solid rgb(0, 0, 0);
    background-color: rgb(0, 0, 0);
    fill: white;
    transition: fill 0.3s;
    cursor: pointer;
    position: absolute;
    /* center */
    left: 50%;
    top: -20%;
}

.cookie-consent-banner:hover .cookies-svg-content {
    fill: #F1D600;
}

.cookies-svg-content path {
    fill: white;
}`, "",{"version":3,"sources":["webpack://./src/css/CookieConsent.css"],"names":[],"mappings":"AAAA,sBAAsB;AACtB;IACI,eAAe;IACf,SAAS;IACT,OAAO;IACP,aAAa;IACb,WAAW;IACX,gDAAgD;IAChD,uBAAuB;IACvB,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,kBAAkB;IAClB,aAAa;IACb,UAAU;IACV,wBAAwB;AAC5B;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,SAAO;IACP,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA;IACI,wCAAwC;IACxC,kCAAkC;IAClC,uBAAuB;IACvB,6BAA6B;IAC7B,wCAAwC;IACxC,yBAAyB;IACzB,0BAA0B;IAC1B,0BAA0B;IAC1B,qBAAqB;AACzB;;AAEA;IACI,wCAAwC;IACxC,uBAAuB;IACvB,mBAAmB;IACnB,uBAAuB;IACvB,4BAA4B;IAC5B,uCAAuC;IACvC,0BAA0B;IAC1B,sBAAsB;AAC1B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,oBAAoB;IACpB,aAAa;IACb,8BAA8B;IAC9B,8BAA8B;IAC9B,WAAW;IACX,qBAAqB;IACrB,eAAe;IACf,kBAAkB;IAClB,WAAW;IACX,SAAS;IACT,SAAS;AACb;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,WAAW;AACf","sourcesContent":["/* CookieConsent.css */\n.cookie-consent-banner {\n    position: fixed;\n    bottom: 0;\n    left: 0;\n    height: 200px;\n    width: 100%;\n    background-color: rgba(0, 0, 0, 0.95) !important;\n    color: white !important;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 15px 30px;\n    z-index: 1005;\n    opacity: 0;\n    transition: opacity 0.5s;\n}\n\n.cookie-consent-banner.visible {\n    opacity: 1;\n}\n\n.cookie-consent-content {\n    flex: 1;\n    text-align: left;\n}\n\n.consent-text {\n    font-size: 24px;\n    color: white !important;\n}\n\n.cookie-consent-buttons {\n    display: flex;\n    justify-content: center;\n    margin-right: 50px;\n}\n\n.cookie-consent-button {\n    background-color: transparent !important;\n    border: 2px solid white !important;\n    color: white !important;\n    padding: 15px 30px !important;\n    /* Increased padding for larger button */\n    margin: 0 30px !important;\n    cursor: pointer !important;\n    font-size: 24px !important;\n    /* Larger font size */\n}\n\n.cookie-consent-button.reject {\n    background-color: transparent !important;\n    border: none !important;\n    /* Thicker border */\n    color: white !important;\n    padding: 5px 10px !important;\n    /* Smaller padding for smaller button */\n    font-size: 16px !important;\n    /* Smaller font size */\n}\n\na.cookie-link {\n    color: #F1D600 !important;\n}\n\n.cookies-svg-content {\n    width: 120px;\n    height: 120px;\n    border-radius: 120px;\n    padding: 20px;\n    border: 2px solid rgb(0, 0, 0);\n    background-color: rgb(0, 0, 0);\n    fill: white;\n    transition: fill 0.3s;\n    cursor: pointer;\n    position: absolute;\n    /* center */\n    left: 50%;\n    top: -20%;\n}\n\n.cookie-consent-banner:hover .cookies-svg-content {\n    fill: #F1D600;\n}\n\n.cookies-svg-content path {\n    fill: white;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
